import { FC, RefObject } from "react";
import { useSelector } from "react-redux";

import ScrolledHeader from "@Pages/HomeV3/components/ScrolledHeader";
import { AppState } from "@Store/index";
import wrapperHOC from "@Utils/wrapperHOC";

import styles from "./SiteHeaderBar.module.scss";
import useSiteHeaderLoginModal from "./useSiteHeaderLoginModal";

type SiteHeaderBarProps = {
  /** On non-home routes the bar is always visible (no hero scroll gate). */
  alwaysVisible?: boolean;
  hideSearchBar?: boolean;
  hidePartnerMenuTiles?: boolean;
  /** When set, the bar appears once this element's top passes the viewport (referral hero). */
  scrollPastRef?: RefObject<HTMLElement | null>;
  heroScrollChrome?: boolean;
  /** Mobile error pages: back control in the logo slot (404, etc.). */
  showBackInsteadOfLogo?: boolean;
  /** Back chevron and Amber logo together (book/payment forms). */
  showBackWithLogo?: boolean;
  /** Page title beside the back control (settings, profile sub-routes). */
  barTitle?: string;
  /**
   * Search sticky stack: bar lives in document flow (not viewport-fixed) so it sits below the app
   * promo banner instead of under it.
   */
  inFlow?: boolean;
};

const SiteHeaderBar: FC<SiteHeaderBarProps> = ({
  alwaysVisible = true,
  hideSearchBar = false,
  hidePartnerMenuTiles = false,
  scrollPastRef,
  heroScrollChrome = false,
  showBackInsteadOfLogo = false,
  showBackWithLogo = false,
  barTitle,
  inFlow = false,
}) => {
  useSiteHeaderLoginModal();
  const isDesktop = useSelector(({ appData }: AppState) => appData.isDesktop);

  return (
    <div className={styles.shell}>
      <ScrolledHeader
        alwaysVisible={alwaysVisible}
        hideSearchBar={hideSearchBar}
        hidePartnerMenuTiles={hidePartnerMenuTiles}
        scrollPastRef={scrollPastRef}
        heroScrollChrome={heroScrollChrome}
        showBackInsteadOfLogo={showBackInsteadOfLogo}
        showBackWithLogo={showBackWithLogo}
        barTitle={barTitle}
        inFlow={inFlow}
        phoneRow
      />
      {!inFlow && (alwaysVisible || heroScrollChrome) ? (
        <div
          className={`${styles.spacer} ${isDesktop ? "" : styles.spacerPhone}`.trim()}
          aria-hidden="true"
        />
      ) : null}
    </div>
  );
};

export default wrapperHOC(SiteHeaderBar, {
  componentName: "SiteHeaderBar",
  showForChina: true,
  showForWhiteLable: false,
});
